// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___f95w","fullView":"styles_fullView__Y51FD"};